import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDtjjn1eyFbmm-uILI52e-x9fIftHCZdxw",
  authDomain: "parambhog-e7dad.firebaseapp.com",
  projectId: "parambhog-e7dad",
  storageBucket: "parambhog-e7dad.appspot.com",
  messagingSenderId: "828503887453",
  appId: "1:828503887453:web:30dbbfe2e4f9bf594987b4",
};

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn("Firebase Messaging not supported:", err);
}

const VAPID_KEY =
  "BEmv9Yi_YueF71ucYIaXsWEyxP4uKknjGJi6p7MNnSScWC-ZkUHU-jszRVpOXyE9N-jxclH6UIfYWKUaIt9JhSk";

/**
 * Request notification permission and return the FCM token.
 */
export const requestNotificationPermission = async () => {
  try {
    if (!messaging) return null;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    let swRegistration = null;
    if ("serviceWorker" in navigator) {
      try {
        swRegistration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
        );
        await navigator.serviceWorker.ready;
      } catch (swErr) {
        console.warn("Service Worker registration issue:", swErr);
      }
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      ...(swRegistration && { serviceWorkerRegistration: swRegistration }),
    });

    return token;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return null;
  }
};

/**
 * Listen for foreground FCM messages.
 */
export const onMessageListener = (callback) => {
  if (!messaging) return null;
  return onMessage(messaging, (payload) => {
    if (callback) callback(payload);
  });
};

